class ApiAutoCaller {
    constructor(axiosFunction, listener, timeout, retryTimeout) {
        this.axiosFunction = axiosFunction;
        this.timeout = timeout;
        this.retryTimeout = retryTimeout;
        this.listener = listener;
        this.run = this.run.bind(this);
    }

    async callAxiosFunction() {
        let response;
        try {
            response = await this.axiosFunction();
        } catch (error) {
            // 429
            if (error.response) {
                response = error.response;
                console.log(response.headers);
            } else {
                // todo
                return this.defaultTimeout;
            }
        }

        if (response.status === 429) {
            return this.retryTimeout;
        }

        try {
            this.listener(response.data);
        } catch (error) {
            console.error(error);
        }

        return this.timeout
    }


    run() {
        this.callAxiosFunction()
            .then(timeout => {
                console.log(`Next call will be in ${timeout}ms`);
                setTimeout(this.run, timeout)
            })
            .catch(error => {
                console.log(`Error... Next call will be in ${this.retryTimeout}ms`);
                setTimeout(this.run, this.retryTimeout)
            })
    }

    start() {
        this.run();
    }

}

export default ApiAutoCaller;
